import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding-bottom":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Сохранить видео")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      size: "small",
      "label-position": "top",
      style: {"max-width":"460px","width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "Видео" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              "model-value": _ctx.videoUrl,
              "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.videoUrl) = $event)),
              placeholder: "Необязательное поле"
            }, null, 8, ["model-value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, { onClick: _ctx.setProductVideo }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}